import { deleteCompany } from "../api/companyService";

/**
 * Hook for deleting a company and syncing with local state.
 * @param {Function} setCompanies - setter from useCompanies
 */
export const useDeleteCompany = (setCompanies) => {
    const remove = async (id) => {
        try {
        await deleteCompany(id);
            // update local state by filtering out the deleted company
            setCompanies((prev) => prev.filter((c) => c.id !== id));
        } catch (error) {
            console.error("Failed to delete company:", error);
            throw error;
        }
    };

    return { remove };
};